import ProductListActions from "@GeriMed/Overrides/Widgets/ProductList/ProductListActions";
import ProductListProductInformation from "@GeriMed/Overrides/Widgets/ProductList/ProductListProductInformation";
import themeColors, { themeFontsSize } from "@GeriMed/styles/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    formularyLockoutMessage?: TypographyProps;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
        `,
    },
    imageWrapper: {
        css: css`
            margin: auto;
            padding: 10px 50px;
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
    formularyLockoutMessage: {
        size: themeFontsSize.size14,
        color: themeColors.drakYellow,
        css: css`
            margin-bottom: 5px;
        `
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}) => {
    const isFormularyLockoutPoduct =
        !product.canAddToCart &&
        product.properties &&
        product.properties["customerHasFormularyLockout"] === "true" &&
        product.properties["onFormulary"] === "false";
    const isReverseFormularyLocked = !product.canAddToCart && product.properties['reverseFormularyLocked'] ==='true';
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            <StyledWrapper {...styles.imageWrapper}>
                {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                <ProductListProductImage
                    showImage={showImage}
                    showCompare={showCompare}
                    showImageBadge={showImageBadges}
                    showTextBadge={showTextBadges}
                />
            </StyledWrapper>
            <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            />
            <ProductListActions showAddToList={showAddToList} showPrice={showPrice} />
            {isFormularyLockoutPoduct && !isReverseFormularyLocked &&(
                <Typography {...styles.formularyLockoutMessage}>{siteMessage("GM_Non_Formulary_Item_Msg")}</Typography>
            )}
            {isReverseFormularyLocked &&(
                <Typography {...styles.formularyLockoutMessage}>{siteMessage("GM_ReverseFormularyLockout_Msg")}</Typography>
            )}
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
